const now = () => (__SERVER__ ? Date.now() : global.performance.now());

export class RuntimePerformance {
	startAt = now();

	start() {
		if (__SERVER__) {
			this.startAt = now();
		}
	}

	now() {
		if (__SERVER__) {
			return now() - this.startAt;
		}

		return now();
	}
}

export const performance = new RuntimePerformance();
